import { getSecureMathRandom } from '@financial/common-utils';

function createSingleton(fn) {
  const memoize = () => {
    const key = 'MEMOIZED_KEY';
    const cache = memoize.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    const result = fn();
    memoize.cache = cache.set(key, result) || cache;
    return result;
  };
  memoize.cache = new Map();
  return memoize;
}
function toSingleton(fn) {
  return createSingleton(fn);
}
function generateRandomString() {
  const MAX_RADIX = 36;
  const DECIMAL_POINT_IDX = 2;
  const randomString = getSecureMathRandom().toString(MAX_RADIX).slice(DECIMAL_POINT_IDX);
  for (var _len = arguments.length, prefixes = new Array(_len), _key = 0; _key < _len; _key++) {
    prefixes[_key] = arguments[_key];
  }
  return [...prefixes, randomString].join('_');
}

export { generateRandomString, toSingleton };
